<template>
    <div class="col-12 account-lookup-view-list">
      <div class="search-padd">
        <form v-on:submit.prevent>
          <div class="col-xs-12 override-padding">
            <div class="crm_admin_heading affiliate_heading_1 text-align-center">Select</div>
            <div class="crm_admin_heading affiliate_heading_2 text-align-left">Industry</div>
            <div class="crm_admin_heading affiliate_heading_3 text-align-center"># of Accounts</div>
            <div class="crm_admin_heading affiliate_heading_4 text-center">Last Updated</div>
          </div>
          <div style="clear: both;"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="view-accountlist">
          
            <div class="tasklist-row" v-for="(industryList, index) in industryLists" v-if="loading === false">

                <div class="row tasklist-item col-12">
                  <div
                    class="crm_admin_field_lists affiliate_heading_1 text-align-center">
                      <input
                        type="checkbox"
                        v-bind:id="'industry_' + index"
                        name="industry"
                        v-model="industry"                        
                        data-vv-as="Industry"
                        :value="industryList.id">
                  </div>
                  <div
                    class="crm_admin_field_lists affiliate_heading_2 text-align-left">
                    {{ industryList.title }}
                  </div>
                  <div
                    class="crm_admin_field_lists affiliate_heading_3 text-align-center">
                    {{ industryList.accounts_count }}
                  </div>
                  <div
                    class="crm_admin_field_lists affiliate_heading_4 text-align-center">
                    {{ industryList.updated_at }}
                  </div>
                  <div><hr></div>
                </div>

            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId'],
      data() {
        return {
          loading: false,
          industryLists: [],
          industry: [],
        }
      },
      components: {

      },
      methods: {
        fetchIndustryLists: function() {
          this.loading = true;

          axios.get('/industrylists', {

          })
          .then((resp) => {
              this.loading = false;
              this.industryLists = resp.data;
          })
          .catch(error => {

          });
        },
        getAccountIndustry: function() {
          axios.get('/account_lookup_industry/' + this.accountId, {

          })
          .then((resp) => {
              this.industry = resp.data;
          })
          .catch(error => {

          });
        },
      },
      created: function () {
        this.verrors.clear();
        this.fetchIndustryLists();
        if (this.accountId > 0) {
          this.getAccountIndustry();
        }
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
    }
</script>


<style scoped>
.account-lookup-view-list .tasklist-item {
    padding: 3px 0px;
}
.affiliate_error { font-size: 14px; margin: 10px 0; }
.affiliate_heading_3 {
  width: 15%;
}
.affiliate_heading_4 {
  width: 35%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_industry_tab.vue